import { render, staticRenderFns } from "./DocumentStatut.vue?vue&type=template&id=d5fd0aec&scoped=true&"
import script from "./DocumentStatut.vue?vue&type=script&lang=js&"
export * from "./DocumentStatut.vue?vue&type=script&lang=js&"
import style0 from "./DocumentStatut.vue?vue&type=style&index=0&id=d5fd0aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fd0aec",
  null
  
)

export default component.exports